/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import useApiRequest from "utils/Apirequest";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { isValidPassword } from "utils/Constant";

import { useMaterialUIController } from "context";


function UpdateDriverPassword() {
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();

  const apiRequest = useApiRequest();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const row_data = location.state || {};

  const getInitialValues = () => ({
    new_password: "",
    confirm_password: "",
    rfidTag: row_data?.rfidTag || "",
  });
  const [errors, setErrors] = useState({
    new_password: "",
    confirm_password: "",
  });

  const [values, setValues] = useState(getInitialValues);

  useEffect(() => {
    setValues(getInitialValues);
  }, [row_data]);

  const createUser = async (new_password) => {
    const payload = {
      driverId: values.rfidTag,
      newpassword: new_password,
    };
    const { data } =
      (await apiRequest(
        "post",
        "users/user/resetpassword",
        payload,
        {},
        { "Content-Type": "application/json" }
      )) || {};
    if (data?.success === true) {
      navigate("/Driver-Management");
    }
  };

  const handleChange = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!values.new_password || !values.confirm_password) {
      return enqueueSnackbar("All fields are necessary", {
        variant: "error",
      });
    }

    if (/\s/.test(values.new_password)) {
      return enqueueSnackbar("Password should not contain spaces", {
        variant: "error",
      });
    }

    if (values.new_password !== values.confirm_password) {
      return enqueueSnackbar("Passwords do not match", {
        variant: "error",
      });
    }

    createUser(values.new_password);
  };

  const reset = (event) => {
    event.preventDefault();
    setValues(getInitialValues());
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
              >
                <MDTypography variant="h6" color="white">
                  Reset Password
                </MDTypography>
              </MDBox>

              <MDBox p={4} component="form" role="form">
                <MDBox p={1}>
                  <div className="disabled-input-wrapper">
                    <MDInput
                      disabled
                      type="text"
                      label="Driver Id"
                      value={values.rfidTag}
                      name="rfidTag"
                      margin="dense"
                      fullWidth
                      onChange={handleChange}

                    />
                  </div>
                </MDBox>
                <MDBox p={1}>

                  <MDInput
                    type={showNewPassword ? "text" : "password"}
                    label="New Password"
                    value={values.new_password}
                    name="new_password"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                    onBlur={() => {
                      setErrors((prev) => ({
                        ...prev,
                        new_password: /\s/.test(values.new_password)
                          ? "Password should not contain spaces"
                          : "",
                      }));
                    }}
                    error={Boolean(errors.new_password)}
                    helperText={errors.new_password}
                    FormHelperTextProps={{
                      sx: {
                        color: "error.main",
                        fontSize: "12px",
                        marginLeft: "4px",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            edge="end"
                            sx={{
                              transform: errors.new_password
                                ? "translateX(-28px)"
                                : "translateX(0px)",
                              transition: "transform 0.3s ease",
                            }}
                          >
                            {showNewPassword ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                </MDBox>

                <MDBox p={1}>
                  <MDInput
                    type={showConfirmPassword ? "text" : "password"}
                    label="Confirm Password"
                    value={values.confirm_password}
                    name="confirm_password"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                    onBlur={() => {
                      let errorMessage = "";

                      if (/\s/.test(values.confirm_password)) {
                        errorMessage = "Password should not contain spaces";
                      } else if (
                        values.confirm_password &&
                        values.confirm_password !== values.new_password
                      ) {
                        errorMessage = "Passwords do not match";
                      }

                      setErrors((prev) => ({
                        ...prev,
                        confirm_password: errorMessage,
                      }));
                    }}
                    error={Boolean(errors.confirm_password)}
                    helperText={errors.confirm_password}
                    FormHelperTextProps={{
                      sx: {
                        color: "error.main",
                        fontSize: "12px",
                        marginLeft: "4px",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                            edge="end"
                            sx={{
                              transform: errors.confirm_password
                                ? "translateX(-28px)"
                                : "translateX(0px)",
                              transition: "transform 0.3s ease",
                            }}
                          >
                            {showConfirmPassword ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </MDBox>

                <style>
                  {`

                  .disabled-input-wrapper div{
                    background-color: ${controller.darkMode ? "#1a2035" : "#f0f2f5"} !important;
                          }
                  `}
                </style>

                <Grid
                  container
                  direction="row"
                  justifyContent="space-around"
                  p={2}
                >
                  <MDButton
                    variant="gradient"
                    color={sidenavColor}
                    onClick={reset}
                  >
                    Reset
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color={sidenavColor}
                    onClick={handleSubmit}
                  >
                    Submit
                  </MDButton>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default UpdateDriverPassword;
